import BrokerSettings from './BrokerSettings';

export default BrokerSettings;
